"use client"
import type { DocumentNode } from "graphql";
import { imageTileCardsGroup, imageTileCardsGroupDataFragmentDoc } from "@gql/graphql";
import { CmsEditable } from "@remkoj/optimizely-cms-react";
import ImageTileCard from "../imageTileCard";
import "./imageTilesGroup.css"
import { useState } from "react";
import { useWindowDimension } from "@/hooks/useWindowDimension";



type ImageTileCardGroupCMSProps = {
    data: imageTileCardsGroup;
    inEditMode?: boolean;
};

// Extend the component type to include the static getDataFragment method
interface ImageTileCardsGroupComponentProps
    extends React.FC<ImageTileCardGroupCMSProps> {
    getDataFragment: () => [string, DocumentNode];
}

const ImageTileCardsGroup: ImageTileCardsGroupComponentProps = ({
    data,
    inEditMode = false,
}: ImageTileCardGroupCMSProps) => {
    const dimension = useWindowDimension();


    return (
        <div className="w-full flex  justify-center">
            <div className={`${dimension.width < 500 ? "flex flex-row gap-4 mx-2 hide-scrollbar items-center w-full lg:max-w-[85%] align-center py-3 overflow-x-scroll" : "grid mx-12 w-full sm:w-auto sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 3xl:grid-cols-6 gap-4 sm:mx-2 items-center py-3"}  `}>
                {/* <div className="grid mx-12 w-full sm:w-auto sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 3xl:grid-cols-6 gap-4 sm:mx-2 items-center py-3"> */}
                {Array.isArray(data.imageTileCards) &&
                    data?.imageTileCards?.map((card, index) => (
                        <CmsEditable
                            key={index}
                            cmsFieldName={`informationMediaCard`}
                            inEditMode={inEditMode}
                        >
                            <ImageTileCard data={card || undefined} inEditMode={inEditMode} />
                        </CmsEditable>
                    ))}
            </div>
        </div>
    );
};

ImageTileCardsGroup.displayName = "Media Card Group";

ImageTileCardsGroup.getDataFragment = () => [
    "ImageTileCardsGroupDataProps",
    imageTileCardsGroupDataFragmentDoc];

// Attach the data fragment to the component
ImageTileCardsGroup.getDataFragment = (): [string, DocumentNode] => [
    "ImageTileCardsGroupDataProps",
    imageTileCardsGroupDataFragmentDoc,
];

export default ImageTileCardsGroup;
